// extracted by mini-css-extract-plugin
module.exports = {"Map":"Map_Map__2ZEd0","title":"Map_title__hupAr"};